import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              The <span style={{ color: "#49A950" }}>Highlights</span>
            </h2>
            <p>
              Integration of key features that enables users to interact with
              the app in a way that delivers a top-notch experience, is what
              sets Kush Me apart from the rest. The app is also equipped with a
              News feature that provides users with regular updates about
              current happenings and the use of marijuana.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Col
          xs={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className="m-auto text-center"
        >
          <StaticImage
            src="../../../images/case-studies/kush-me/tek_img_05.webp"
            alt="TekRevol"
            layout="constrained"
            placeholder="blurred"
            formats={["webp"]}
            width={1920}
            height={651}
          />
        </Col>
      </Container>
    </section>
  );
}

export default Highlights;
